module.exports = __webpack_public_path__ + "img/2.f780f7f1.jpg";